<div class="split-btn" [class.off]="!active()" [class.disabled]="disabled()">
  <button type="button" class="split-btn__main" [disabled]="disabled()" (click)="onToggle()">
    <ng-content></ng-content>
  </button>
  <span class="split-btn__divider"></span>
  <button
    type="button"
    class="split-btn__chevron"
    [disabled]="disabled()"
    [andorContextMenuTriggerFor]="optionsMenu"
    #chevronTrigger="andorContextMenuTrigger">
    <fa-duotone-icon [icon]="faChevronDown" class="split-btn__chevron-icon"></fa-duotone-icon>
  </button>
</div>

<andor-context-menu #optionsMenu mode="styled" yPosition="above">
  <div class="split-btn__popover-content">
    @if (popoverTitle()) {
      <div class="split-btn__popover-title">{{ popoverTitle() | translate }}</div>
    }
    @let optionList = options();
    @if (optionList && optionList.length > 0) {
      @for (option of optionList; track option.id) {
        <button
          type="button"
          class="split-btn__popover-item"
          [class.selected]="option.id === selectedOptionId()"
          (click)="onSelect(option); chevronTrigger.closeMenu()">
          {{ option.name }}
        </button>
      }
    } @else {
      <div class="split-btn__popover-empty">{{ 'No options available' | translate }}</div>
    }
  </div>
</andor-context-menu>
